import React from "react";
import {Link} from "react-router-dom";
import logo from "../../images/logo.png";                                                                                                                                                                               
const Navbar = () => {
	return(
		<div className="container-fluid navigation_bar">
			<nav className="navscroll navbar fixed-top navbar-expand-lg navbar-light py-2 px-3">
				<div className="container">
				  <Link className="navbar-brand" to="/" style={{color: "#00747E", fontSize: 20 + "px", fontWeight: 600}}><img src={logo} alt="Beryls" style={{height: "48px", width: "auto", borderRadius: "6px"}} /></Link>
				  <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
				   {/* <span className="text-white"><MenuIcon style={{ fontSize: 35 }} /></span>*/}
				  </button>
				</div>
			</nav>
		</div>
	
	);
};


export default Navbar;